var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLeftArrowLg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 11.67v.003c0 .418.201.786.504.991l5.545 5.66c.446.456 1.17.456 1.616 0a1.184 1.184 0 000-1.649L7.908 12.84h11.025c.59 0 1.067-.523 1.067-1.167s-.478-1.167-1.067-1.167H7.896l3.77-3.848a1.184 1.184 0 000-1.65 1.127 1.127 0 00-1.617 0l-5.587 5.704c-.238.18-.405.46-.45.786A1.198 1.198 0 004 11.67z"
  })));
}
export default SvgIconLeftArrowLg;